import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SmoothScroll = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change with smooth behavior
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

export default SmoothScroll;
